




import Class from './c-chart-budget-view';
export default Class;
